import * as Cesium from 'cesium';
import { DataFeedAlert, DataFeedAlertAttributes } from './data-feed-alert.service';
import { CameraService } from './camera.service';
import { OrganizationUtilService } from './organization-util.service';
import { DataService } from './data.service';
import _ from 'lodash';
import { CoreService } from './core.service';

export class GenericAlert extends DataFeedAlert {
  alertEntity: any;
  override timestamp: number;
  name: string;
  override shortDescription: string;
  description: string;
  override class = 'alert';
  override src = 'assets/img/alert/DATAWATCH.png';
  override type = 'ALERT';
  country: string;
  start: string;
  end: string;
  createdAt: string;
  status: string;
  alertRead?: boolean;
  alertId: string;
  layerDataSource: any = null;
  buildingName: string;
  floorNumber: number;
  override perimeter: any;
  localTime: string;
  isVisibleInOverlappingEntitiesUI = true;
  override entity: any;
  userId: string;
  private arcAngelService: any;
  private buildingCameraService: any;
  // private rootScope: any;
  // private dataService: DataService;
  

  constructor(
    camera: CameraService,
    orgUtil: OrganizationUtilService,
    buildingCameraService: any,
    rootScope: any,
    private dataService: DataService,
    private core: CoreService,
    attributes: any,
    entity?: any
  ) {
    super(camera, attributes);
    this.arcAngelService = orgUtil;
    this.buildingCameraService = buildingCameraService;
    this.dataService = dataService;
    this.timestamp = new Date(attributes.createdAt).getTime();
    this.name = attributes.name;
    this.shortDescription = this.getTruncatedStr(attributes.name);
    this.description = attributes.description;
    this.class = 'alert';
    this.src = 'assets/img/alert/DATAWATCH.png';
    this.type = 'ALERT';
    this.country = attributes.country;
    this.start = this.getStartDate(attributes);
    this.end = this.getEndDate(attributes);
    this.createdAt = this.getCreatedAtDate(attributes);
    this.status = 'active';
    if (attributes.dismissedAt && attributes.dismissedAt.toLowerCase() !== 'infinity') {
      this.status = 'dismissed';
    } else if (this.isExpired(attributes)) {
      this.status = 'expired';
    }
    if (attributes.viewedAt && attributes.viewedAt.toLowerCase() !== 'infinity') {
      this.alertRead = true;
    }
    this.alertId = attributes.id;
    this.layerDataSource = null;
    this.buildingName = attributes.buildingName;
    this.floorNumber = attributes.floorNumber;
    this.perimeter = attributes.perimeter;
    const date = new Date(attributes.createdAt);
    this.localTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    this.isVisibleInOverlappingEntitiesUI = true;
    this.entity = entity;
    this.userId = attributes.userId;
  }

  showInOverlappingEntitiesUI(): boolean {
    return this.isVisibleInOverlappingEntitiesUI;
  }

  showInfo(scope?: any): void {
    if (this.entity && typeof (this.entity as any).viewDetailsWindow === 'function') {
      (this.entity as any).viewDetailsWindow(scope);
    }
  }

  override goTo(): void {
    // Should zoom to building location for C-CURE alert.
    // let facility: any = undefined;
    // _.forEach(this.arcAngelService.data.myBluetoothFacilityPins, (fac: any) => {
    //   if (fac.name && fac.name === this.buildingName) {
    //     facility = fac;
    //     return false;
    //   }
    // });
    // if (facility && typeof facility.viewDetailsWindow === 'function') {
    //   facility.viewDetailsWindow();
    //   // show floor
    //   let floor: any = undefined;
    //   if (facility.buildingMapEntity && Array.isArray(facility.buildingMapEntity.floorPerimeters)) {
    //     _.forEach(facility.buildingMapEntity.floorPerimeters, (fl: any) => {
    //       if (fl.floorNumber === this.floorNumber) {
    //         floor = fl;
    //       }
    //     });
    //     if (floor && typeof this.buildingCameraService.viewArea === 'function') {
    //       this.buildingCameraService.viewArea(this.rootScope.$new(), floor);
    //     }
    //   }
    // }
  }

  zoomTo(): void {
    if (this.layerDataSource && this.camera && typeof this.camera.flyToEntity === 'function') {
      this.camera.flyToEntity(this.layerDataSource);
    }
  }

  getSensorPosition(): Cesium.Cartesian3 | null {
    let sensorPosition = null;
    const sensorId = this.entity?.object?.sensorId;
    if (sensorId) {
      const sensors = _.filter(this.dataService?.sensorList.accessControlList, (sensor: any) => sensor.id === sensorId);
      if (sensors.length > 0) {
        const position = sensors[0].position;
        if (position) {
          const lat = position.coordinates[1];
          const lon = position.coordinates[0];
          const perimeterId = sensors[0].perimeterId;
          const perimeter =this.arcAngelService.data.myPerimeters[perimeterId];
          let perimeterHeight;
          if (perimeter) {
            perimeterHeight = perimeter.height;
          }
          if (lat && lon && perimeterHeight) {
            sensorPosition = Cesium.Cartesian3.fromDegrees(lon, lat, perimeterHeight);
          }
        }
      }
    }
    return sensorPosition;
  }

  getSensorAltitude(): number {
    let perimeterHeight = 0;
    const sensorId = this.entity?.object?.sensorId;
    if (sensorId) {
      const sensors = _.filter(this.dataService.sensorList.accessControlList, (sensor: any) => sensor.id === sensorId);
      if (sensors.length > 0) {
        const perimeterId = sensors[0].perimeterId;
        const perimeter = this.arcAngelService.data.myPerimeters[perimeterId];
        if (perimeter) {
          perimeterHeight = perimeter.height;
        }
      }
    }
    return perimeterHeight;
  }

  getAlertPointFeatureLatLon(): { lat: number; lon: number } | null {
    let feature;
    let lat;
    let lon;
    const features = _.filter(this.entity?.object?.AlertFeatures, (o: any) => o.geometry.type.toLowerCase() === 'point');
    if (features.length > 0) {
      feature = features[0];
    }
    if (feature) {
      lat = feature.geometry.coordinates[1];
      lon = feature.geometry.coordinates[0];
    }
    if (lat && lon) {
      return { lat, lon };
    }
    return null;
  }

  getObservationPosition(): Cesium.Cartesian3 | null {
    const observationId = this.entity?.object?.observationId;
    if (!observationId) {
      return null;
    }
    let observationLat;
    let observationLon;
    const latlon = this.getAlertPointFeatureLatLon();
    if (latlon) {
      observationLat = latlon.lat;
      observationLon = latlon.lon;
    }
    const observationAltitude = this.getObservationAltitude();
    if (observationLat && observationLon) {
      return Cesium.Cartesian3.fromDegrees(observationLon, observationLat, observationAltitude);
    }
    return null;
  }

  getObservationAltitude(): number {
    const observationId = this.entity?.object?.observationId;
    if (!observationId) {
      return 0;
    }
    let observationAltitude = 0;
    let observationPerimeterId: any;
    if (this.entity?.object?.perimeterIds?.length > 0) {
      observationPerimeterId = this.entity.object.perimeterIds[0];
      const perimeters = _.filter(this.arcAngelService.data.myPerimeters, (o: any) => o.arcAngelId === observationPerimeterId);
      if (perimeters.length > 0) {
        observationAltitude = perimeters[0].height;
      }
    }
    return observationAltitude;
  }

  getBuildingHeight(): number {
    if (!this.entity?.object?.buildingInfo || this.entity.object.buildingInfo.length === 0) {
      return 0;
    }
    const buildings = _.filter(this.arcAngelService.data.myBuildings, (o: any) => o.perimeterId === this.entity.object.buildingInfo[0].building.arcAngelId);
    const building = buildings.length > 0 ? buildings[0] : null;
    if (!building) {
      return 0;
    }
    const altitudes = _.map(
      _.filter(this.arcAngelService.data.perimeterAreaMap, (area: any) => area.building.perimeterId === building.perimeterId),
      (o: any) => o.extrudedHeight
    );
    let maxHeight = 0;
    if (altitudes.length > 0) {
      maxHeight = Math.max(...altitudes);
    }
    if (maxHeight < 0) {
      maxHeight = 0;
    }
    return maxHeight;
  }

  getStartDate(attr: any): string {
    if (attr && attr.duration && attr.duration.start_date) {
      const d = new Date(attr.duration.start_date * 1000);
      let str = d.toISOString().replace('T', ' ').replace(/\.\d\d\dZ/, ' UTC');
      str = str.replace(/:\d\d UTC/, ' UTC');
      return str;
    }
    return '';
  }

  getEndDate(attr: any): string {
    if (attr && attr.duration && attr.duration.end_date) {
      const d = new Date(attr.duration.end_date * 1000);
      let str = d.toISOString().replace('T', ' ').replace(/\.\d\d\dZ/, ' UTC');
      str = str.replace(/:\d\d UTC/, ' UTC');
      return str;
    }
    return '';
  }

  getCreatedAtDate(attr: any): string {
    if (attr && attr.createdAt) {
      const d = new Date(attr.createdAt);
      let str = d.toISOString().replace('T', ' ').replace(/\.\d\d\dZ/, ' UTC');
      str = str.replace(/:\d\d UTC/, ' UTC');
      return str;
    }
    return '';
  }

  getTruncatedStr(str: string): string {
    const str1 = str.slice(0, 70).split(' ');
    let str2 = str1.join(' ');
    if (str2.length < str.length) {
      str2 += ' ...';
    }
    return str2;
  }

  isExpired(attr: any): boolean {
    if (
      attr.expiresAt &&
      attr.expiresAt.toLowerCase() !== 'infinity' &&
      new Date(attr.expiresAt).valueOf() < Date.now()
    ) {
      return true;
    }
    return false;
  }

  getAlertPosition(): Cesium.Cartesian3 | null {
    const latlon = this.getAlertLatLon();
    const altitude = this.getAlertHeight();
    if (
      latlon &&
      typeof latlon.lat === 'number' &&
      typeof latlon.lon === 'number' &&
      !isNaN(latlon.lat) &&
      !isNaN(latlon.lon)
    ) {
      return Cesium.Cartesian3.fromDegrees(latlon.lon, latlon.lat, altitude);
    }
    return null;
  }

  getAlertHeight(): number {
    const observationAltitude = this.getObservationAltitude();
    const sensorAltitude = this.getSensorAltitude();
    let height = observationAltitude || sensorAltitude || null;
    if (!height) {
      height = 0;
    }
    return height;
  }

  getAlertBuildingLatLon(): { lat: number; lon: number } | null {
    if (this.entity?.object?.buildingInfo?.length > 0) {
      const lon = this.entity.object.buildingInfo[0].building.centerpoint.longitude || this.entity.object.buildingInfo[0].building.centerLongitude;
      const lat = this.entity.object.buildingInfo[0].building.centerpoint.latitude || this.entity.object.buildingInfo[0].building.centerLatitude;
      return { lat, lon };
    }
    return null;
  }

  getAlertLatLon(): { lat: number; lon: number } | null {
    return this.getAlertPointFeatureLatLon() || this.getAlertBuildingLatLon() || null;
  }

  drawGeometry(): void {
    if (this.layerDataSource) {
      return;
    }
    const polygons = _.filter(this.entity?.object?.AlertFeatures, (o: any) =>
      ['Polygon', 'MultiPolygon', 'Line', 'Point'].includes(o.geometry.type)
    );
    if (polygons.length === 1 && polygons[0].geometry.type === 'Point') {
      polygons[0].geometry.coordinates[2] = this.getAlertHeight();
    }
    if (polygons.length > 0) {
      const features = _.map(polygons, (p: any) => ({ type: 'Feature', geometry: p.geometry }));
      polygons[0].properties = polygons[0].properties || {};
      const geo = { type: 'FeatureCollection', features };
      let stroke = polygons[0].properties.stroke || this.entity.object.incidentCategory.color || '00ff00';
      const fillOpacity = polygons[0].properties['fill-opacity'] || 0.25;
      if (stroke) {
        stroke = stroke.replace('#', '');
      }
      let fill = polygons[0].properties.fill || this.entity.object.incidentCategory.color || '00ff00';
      if (fill) {
        fill = fill.replace('#', '');
      }
      this.core.getViewer().dataSources.add(Cesium.GeoJsonDataSource.load(geo, {
        stroke: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#' + stroke), 1.0),
        fill: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#' + fill), fillOpacity),
        // closeBottom: false,
        markerColor: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#' + stroke), 1.0),
      })).then((data: any) => {
        this.layerDataSource = data;
        this.layerDataSource.show = true;
      });
    }
  }

  removeGeometry(): void {
    this.core.getViewer().dataSources.remove(this.layerDataSource);
    this.layerDataSource = null;
  }
}    